import React from 'react';
import { NoDataIcon, NoDataWrapper } from '../Charts/Charts.styled';
import { ReactComponent as FileTextIcon } from '../../assets/icons/base/file-text.svg';
import { Typography } from '@mui/material';
import { BoxProps } from '@mui/system';

const NoData = (props: BoxProps) => {
  return (
    <NoDataWrapper {...props}>
      <NoDataIcon>
        <FileTextIcon stroke="currentColor" style={{ height: '20px', width: '20px' }} />
      </NoDataIcon>
      <Typography variant="tmd" fontWeight="500">
        No data found
      </Typography>
      <Typography variant="tsm" fontWeight="400" color="grey.500">
        The filters you selected do not have sufficient data. Please modify your filters at the top.
      </Typography>
    </NoDataWrapper>
  );
};

export default NoData;
